var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "table-wrapper" }, [
    _c("p", { staticClass: "table-title", class: { "fz-20": _vm.inModal } }, [
      _vm._v(
        "Актуальные уведомления на " + _vm._s(_vm.dateParser(_vm.actualDate))
      ),
    ]),
    _vm._v(" "),
    _c(
      "table",
      {
        staticClass: "table",
        class: { "tile-table": !_vm.inModal, "modal-table": _vm.inModal },
      },
      [
        _c("thead", [
          _c("tr", [
            _c("th", { staticClass: "ws-nw" }, [_vm._v("№ п/п")]),
            _vm._v(" "),
            _c("th", { staticClass: "ws-nw" }, [_vm._v("№ уведомления")]),
            _vm._v(" "),
            _c("th", [_vm._v("Дата")]),
            _vm._v(" "),
            _c("th", [_vm._v("Залогодержатель")]),
            _vm._v(" "),
            _vm.inModal ? _c("th", [_vm._v("Номер имущества")]) : _vm._e(),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "tbody",
          _vm._l(_vm.list, function (z, i) {
            return _c("tr", { key: i }, [
              _c("td", { staticClass: "ws-nw" }, [
                _vm._v(_vm._s(_vm.pagination.min_row_on_page + i)),
              ]),
              _vm._v(" "),
              _c("td", [
                _vm._v(
                  _vm._s(z.notification_number ? z.notification_number : "—")
                ),
              ]),
              _vm._v(" "),
              _c("td", { staticClass: "ws-nw" }, [
                _vm._v(_vm._s(z.date_reg ? _vm.dateParser(z.date_reg) : "—")),
              ]),
              _vm._v(" "),
              _c("td", { class: { "w-30": _vm.inModal } }, [
                _vm._v(_vm._s(z.pledgees ? z.pledgees : "—")),
              ]),
              _vm._v(" "),
              _vm.inModal
                ? _c("td", { staticClass: "w-30" }, [
                    _vm._v(_vm._s(z.property_number ? z.property_number : "—")),
                  ])
                : _vm._e(),
            ])
          }),
          0
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }